module.exports = __webpack_public_path__ + "guide-service04.fe0a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/guide-service04.svg
// module id = ./src/_asset/sources/assets/images/@svg/guide-service04.svg
// module chunks = main